import type { ICellRendererComp, ICellRendererParams } from 'ag-grid-community'
import type { BadgeData } from '../utils/dom'
import type { StepperValueItem } from '../utils/transforms'
import { cloneBadgeNode, updateBadge } from './badge'

const stepperLabel = (item: StepperValueItem): string =>
  item.title || item.label || item.value

const findStepperItem = (
  label: string,
  values: readonly StepperValueItem[]
): StepperValueItem | undefined =>
  values.find((item) => stepperLabel(item) === label || item.value === label)

const stepperBadgeData = (
  label: string,
  values: readonly StepperValueItem[]
): BadgeData => {
  const item = findStepperItem(label, values)

  if (!item) {
    return { label }
  }

  return {
    label: stepperLabel(item),
    color: item.color,
    icon: item.icon
  }
}

export class StepperRichSelectRenderer implements ICellRendererComp {
  private eGui: HTMLElement | undefined

  getStepperValues(): readonly StepperValueItem[] {
    return []
  }

  init(params: ICellRendererParams): void {
    const label =
      typeof params.value === 'string'
        ? params.value
        : String(params.value ?? '')
    const badge = cloneBadgeNode()

    updateBadge(badge, stepperBadgeData(label, this.getStepperValues()))

    this.eGui = badge
  }

  getGui(): HTMLElement {
    return this.eGui || document.createElement('div')
  }

  refresh(_params: ICellRendererParams): boolean {
    return false
  }

  destroy(): void {
    this.eGui = undefined
  }
}
